/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  ClickWrapper,
  DarkText,
  EditIconBox,
  FlexWrapper,
  fontFamilys,
  GreyText,
  HeadingTable,
  PurpleText,
  TitleBox
} from '../../../theme/common_style';
import TextArea from 'antd/es/input/TextArea';
import { Rate, Skeleton, Table } from 'antd';
import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';
import AddMemeberModal from './AddMemeberModal';
import { useSelector } from 'react-redux';
import { getProjectDetails, getProjectTotalBilling } from '../../../redux/project/apiRoute';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  activeStatusTag,
  AmountInPattern,
  checkPermission,
  formatMinToHours,
  generateEmployeeImgUrl,
  getFullName
} from '../../../utils/common_functions';
import { AvatarGroup, AvatarGroupRow } from '../../../components/common/AvatarGroup';
import {
  actionTypeEnums,
  billingType,
  projectBillingType,
  projectCategories,
  projectCondition,
  projectPhase,
  ProjectSource,
  projectStatusOption,
  showLeadManager
} from '../../../utils/constant';
import UserInfoModal from '../../../components/common/UserInfoModal';
import { useCurrentModule } from '../../../hooks/useCurrentModule';
import { EditIcon, ThemeAddIcon } from '../../../theme/SvgIcons';
import BillingModal from './BillingModal';
import ProjectStatusModal from './ProjectStatusModal';

const GeneralInfo = ({ setEditData, editData, updated, loading, setLoading }) => {
  const { isEmployee } = useSelector((e) => e.userInfo);
  const location = useLocation();
  const { id } = location.state || {};
  const [data, setData] = useState(null);
  const [details, setDetails] = useState([]);
  const [billingDetails, setBillingDetails] = useState([]);
  const [projectBilling, setProjectBilling] = useState([]);
  const { isManager } = useSelector((state) => state?.projectSlice);
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  let permissionSection = useCurrentModule();
  const canUpdate = checkPermission(permissionSection, actionTypeEnums.UPDATE, permissions);
  const [infoModal, setInfoModal] = useState(false);

  const [assigneeBillingIds, setAssigneeBillingIds] = useState([]);
  const [billingModal, setBillingModal] = useState(false);
  const [selectedBillingEmp, setSelectedBillingEmp] = useState(null);
  const [openMemberModal, setOpenMemberModal] = useState(false);

  const [updateStatus, setUpdateStatus] = useState(false);

  const mapAssigneeBillingIds = (projectAssignees, billingData, hiredData, projectId) => {
    const mapped = projectAssignees.map((assignee) => {
      const checkAssignId = billingData.find((val) => val?.employee_id === assignee?.emp_id?.id);
      const billing_id_name = hiredData.find((val) => val?.id === checkAssignId?.billing_id);
      return {
        emp_id: assignee?.emp_id?.id || '',
        emp_code: assignee?.emp_id?.emp_code || 'N/A',
        emp_name:
          getFullName(
            assignee?.emp_id?.first_name,
            assignee?.emp_id?.middle_name,
            assignee?.emp_id?.last_name
          ) || 'N/A',
        emp_role: assignee?.designation || 'N/A',
        billing_id: checkAssignId?.billing_id || '',
        weekly_billing_limit: checkAssignId?.weekly_billing_limit || '',
        project_id: projectId || '',
        billing_id_name: billing_id_name?.name || 'N/A'
      };
    });

    const unique = mapped.filter(
      (item, index, self) => index === self.findIndex((t) => t.emp_id === item.emp_id)
    );
    return unique;
  };

  const handleGetDetails = async () => {
    try {
      setLoading(true);
      const res = await getProjectDetails(id);
      if (res?.statusCode === 200) {
        const projectData = res?.data;
        setData(projectData);

        const assigneeBillingIds = mapAssigneeBillingIds(
          projectData?.project_Assignee || [],
          projectData?.billing_data || [],
          projectData?.hired || [],
          projectData?.id
        );
        setAssigneeBillingIds(assigneeBillingIds);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  const projectTotalBilling = async () => {
    try {
      setLoading(true);
      const res = await getProjectTotalBilling(id);
      if (res?.statusCode === 200) {
        const result = res?.data;
        setProjectBilling(result);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const project_incharge_members = editData?.project_Assignee.filter(
    (assignee) => assignee.role === 'Project Incharge'
  );

  const employee_members = editData?.project_Assignee.filter(
    (assignee) => assignee.role === 'Developer'
  );

  const project_manager_members = editData?.project_Assignee?.find(
    (assignee) => assignee.role === 'Project Manager'
  );

  useEffect(() => {
    handleGetDetails();
    if (!isEmployee) {
      projectTotalBilling();
    }
  }, [updated]);

  useEffect(() => {
    if (data) {
      const pType =
        projectBillingType.find((type) => type.value === data?.project_type)?.label || 'N/A';
      const pCondition =
        projectCondition.find((type) => type.value === data?.project_condition)?.label || 'N/A';
      const pPhase =
        projectPhase.find((type) => type.value === data?.project_phase)?.label || 'N/A';
      const pPlatform =
        projectCategories
          .filter((item) => data?.project_platform?.includes(item.value))
          .map((item) => item.label) || 'N/A';

      const newDetails = [
        { key: 'Client Name', value: data?.client?.name || 'N/A' },
        { key: 'Project Type', value: pType },
        { key: 'Project Condition', value: pCondition },
        { key: 'Project Phase', value: pPhase },
        { key: 'Category', value: pPlatform.join(', ') },
        {
          key: 'Deadline',
          value: data?.deadline ? moment(data?.deadline).format('DD MMM YYYY') : 'N/A'
        },
        ...(!isEmployee ? [{ key: 'Lead Generation', value: data?.hiring_type || 'N/A' }] : []),
        ...(data?.rating ? [{ key: 'Rating', value: data?.rating }] : [])
      ];

      if (showLeadManager?.includes(data?.hiring_type) && !isEmployee) {
        newDetails.push({
          key: 'Lead Manager',
          value:
            getFullName(
              data?.lead_manager_details?.first_name,
              data?.lead_manager_details?.middle_name,
              data?.lead_manager_details?.last_name
            ) || 'N/A'
        });
      }

      if (!isEmployee) {
        const pSource =
          ProjectSource.find((type) => type.value === data?.sourced_from)?.label || 'N/A';
        const pHiredIds = data?.hired?.map((val) => val?.name) || [];
        const billingTypeLabel =
          billingType.find((type) => type.value === data?.billing_type)?.label || 'N/A';

        const billingInfo = [
          { key: 'Billing Type', value: billingTypeLabel },
          { key: 'Sourced From', value: pSource },
          { key: 'Hired IDs', value: pHiredIds.length > 0 ? pHiredIds.join(', ') : 'N/A' },
          { key: 'No. of Hours', value: `${data?.no_of_hours || '0'} hrs` },
          { key: 'Weekly Billing', value: `${data?.weekly_billing || '0'} hrs` },
          { key: 'Project Budget', value: `$${AmountInPattern(data?.budget || 0)}` }
        ];
        setBillingDetails(billingInfo);
      }

      setEditData(data);
      setDetails(newDetails);
    }
  }, [data]);

  const handleStatusModal = () => {
    setUpdateStatus(true);
  };

  const columns = [
    {
      title: 'Emp Code',
      render: (_, record) => <span>{record?.emp_code || 'N/A'}</span>
    },
    {
      title: 'Emp Name',
      render: (_, record) => {
        let data = [
          {
            name: record?.emp_name,
            src: generateEmployeeImgUrl(record?.emp_id),
            id: record?.emp_id
          }
        ];

        return (
          <FlexWrapper wrap="no-wrap" justify={'start'} gap={'6px'}>
            <AvatarGroup avatars={data} />
            <p style={{ fontSize: '14px', margin: 0 }}>{record?.emp_name}</p>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Emp Role',
      render: (_, record) => (
        <>
          <span>{record?.emp_role || 'N/A'}</span>
        </>
      )
    },
    {
      title: 'Billing Id',
      render: (_, record) => (
        <>
          <span>{record?.billing_id_name || 'N/A'}</span>
        </>
      )
    },
    {
      title: 'Weekly Billing Limit',
      render: (_, record) => (
        <>
          <span>
            {record?.weekly_billing_limit ? record?.weekly_billing_limit + ' hrs' : 'N/A'}
          </span>
        </>
      )
    },
    ...(!isEmployee
      ? [
          {
            title: 'Billing ID',
            render: (_, record) => (
              <FlexWrapper gap="4px" justify="start" align="center" cursor="pointer">
                {record?.billing_id ? (
                  <EditIconBox
                    canUpdate={canUpdate}
                    onClick={() => {
                      setBillingModal(true);
                      setSelectedBillingEmp(record);
                    }}>
                    <EditIcon />
                  </EditIconBox>
                ) : (
                  <EditIconBox
                    canUpdate={canUpdate}
                    onClick={() => {
                      setBillingModal(true);
                      setSelectedBillingEmp(record);
                    }}>
                    <ThemeAddIcon />
                  </EditIconBox>
                )}
              </FlexWrapper>
            )
          }
        ]
      : [])
  ];

  return (
    <>
      {updateStatus && (
        <ProjectStatusModal
          open={updateStatus}
          close={() => setUpdateStatus(false)}
          data={data}
          handleListing={handleGetDetails}
        />
      )}
      {billingModal && (
        <BillingModal
          open={billingModal}
          onClose={() => {
            setBillingModal(false);
            setSelectedBillingEmp(null);
          }}
          selectedBillingEmp={selectedBillingEmp || {}}
          options={data?.hired || []}
          assigneedEmps={data?.billing_data || []}
          reload={handleGetDetails}
        />
      )}
      {infoModal && (
        <UserInfoModal
          visible={infoModal ? true : false}
          onClose={() => setInfoModal(false)}
          user={infoModal}
        />
      )}
      {loading ? (
        <ContentWrapper>
          <Skeleton active title={false} paragraph={{ rows: 15 }} />
        </ContentWrapper>
      ) : (
        <ContentWrapper>
          <FlexWrapper justify="space-between" margin="0 0 16px">
            <FlexWrapper direction="column" align="start" gap="4px">
              <HeadingTable>{data?.name || 'N/A'}</HeadingTable>
              <PurpleText>
                <span style={{ fontWeight: 600 }}>Start Date: </span>
                {data?.start_date ? moment(data?.start_date).format('DD MMM YYYY') : 'N/A'}
              </PurpleText>
            </FlexWrapper>
            {activeStatusTag(projectStatusOption, 'value', data?.status, handleStatusModal)}
          </FlexWrapper>
          <Grid>
            {details.map((item, index) => (
              <FlexWrapperInfo
                key={index}
                direction="column"
                justify="start"
                align="start"
                gap="3px">
                <GreyText size="14px">{item?.key}</GreyText>
                {item?.key === 'Rating' ? (
                  <Rate allowHalf disabled value={item?.value} />
                ) : (
                  <DarkText>{item?.value}</DarkText>
                )}
              </FlexWrapperInfo>
            ))}
          </Grid>
          {data?.notes?.trim() && (
            <FlexWrapper direction="column" align="start" gap="6px" margin="20px 0 10px">
              <DarkText>Note</DarkText>
              <TextArea
                readOnly
                value={data?.notes}
                autoSize={{ minRows: 1 }}
                style={{ resize: 'none', overflow: 'hidden' }}
                No
                scrollbarvalue={data?.notes}
                rows={4}
              />
            </FlexWrapper>
          )}
          {!isEmployee && (
            <>
              <FlexWrapper direction="column" gap="6px" align="start" margin="30px 0">
                <TitleBox>Billing Details</TitleBox>
                <Grid style={{ width: '100%', margin: '20px 0 0' }}>
                  {billingDetails?.map((item, index) => (
                    <FlexWrapperInfo
                      key={index}
                      direction="column"
                      justify="start"
                      align="start"
                      gap="3px">
                      <GreyText size="14px">{item?.key}</GreyText>

                      <DarkText>{item?.value}</DarkText>
                    </FlexWrapperInfo>
                  ))}
                  <FlexWrapperInfo direction="column" justify="start" align="start" gap="3px">
                    <GreyText size="14px">Project Name</GreyText>

                    <DarkText>{projectBilling?.project_name}</DarkText>
                  </FlexWrapperInfo>
                  <FlexWrapperInfo direction="column" justify="start" align="start" gap="3px">
                    <GreyText size="14px">Total Project Billing</GreyText>

                    <DarkText>{formatMinToHours(projectBilling?.total_billable_mins)}</DarkText>
                  </FlexWrapperInfo>
                </Grid>
              </FlexWrapper>
            </>
          )}
          <FlexWrapper direction="column" gap="6px" align="start">
            <TitleBox>Team</TitleBox>

            <ManagerInchargeWrapper>
              {(canUpdate || project_manager_members?.emp_id?.first_name) && (
                <Container width="100%">
                  <DarkText>Project Manager</DarkText>
                  <FlexWrapper gap="4px" justify="start" margin="10px 0 0">
                    {project_manager_members?.emp_id?.first_name && (
                      <ClickWrapper
                        onClick={() =>
                          (canUpdate || isManager) && setInfoModal(project_manager_members)
                        }
                        style={{ cursor: 'pointer' }}>
                        <AvatarGroupRow
                          name={getFullName(
                            project_manager_members?.emp_id?.first_name,
                            project_manager_members?.emp_id?.middle_name,
                            project_manager_members?.emp_id?.last_name
                          )}
                          baseUrl={generateEmployeeImgUrl(project_manager_members?.emp_id?.id)}
                          role={project_manager_members?.designation}
                        />
                      </ClickWrapper>
                    )}

                    {canUpdate && (
                      <>
                        <AddMembers setData={setOpenMemberModal} type="Project Manager" />
                        {openMemberModal?.type === 'Project Manager' && (
                          <AddMemeberModal
                            open={openMemberModal?.open}
                            setOpen={setOpenMemberModal}
                            type={'Project Manager'}
                            selectedUser={project_manager_members ? [project_manager_members] : []}
                            handleListing={handleGetDetails}
                            filterOption={[...(employee_members || [])]}
                          />
                        )}
                      </>
                    )}
                  </FlexWrapper>
                </Container>
              )}

              {(canUpdate || project_incharge_members?.length > 0) && (
                <Container width={'100%'}>
                  <DarkText>Project Incharge</DarkText>
                  <FlexWrapper gap="4px" justify="start" margin="10px 0 0">
                    {project_incharge_members?.map((incharge) => {
                      const info = incharge?.emp_id || {};
                      const name = getFullName(
                        info?.first_name,
                        info?.middle_name,
                        info?.last_name
                      );
                      return (
                        <ClickWrapper
                          key={info?.id}
                          onClick={() => (canUpdate || isManager) && setInfoModal(incharge)}
                          style={{ cursor: 'pointer' }}>
                          <AvatarGroupRow
                            key={info?.id}
                            name={name}
                            baseUrl={generateEmployeeImgUrl(info?.id)}
                            role={incharge?.designation}
                          />
                        </ClickWrapper>
                      );
                    })}
                    {canUpdate && (
                      <>
                        <AddMembers setData={setOpenMemberModal} type="Project Incharge" />
                        {openMemberModal?.type === 'Project Incharge' && (
                          <AddMemeberModal
                            open={openMemberModal?.open}
                            setOpen={setOpenMemberModal}
                            type={'Project Incharge'}
                            selectedUser={project_incharge_members}
                            handleListing={handleGetDetails}
                            filterOption={[...(employee_members || [])]}
                          />
                        )}
                      </>
                    )}
                  </FlexWrapper>
                </Container>
              )}
            </ManagerInchargeWrapper>

            <FlexWrapper width="100%" justify="start" wrap="nowrap">
              <Container width="100%">
                <DarkText>Team Members</DarkText>
                <FlexWrapper gap="4px" justify="start" margin="10px 0 0">
                  {employee_members?.map((incharge) => {
                    const info = incharge?.emp_id || {};
                    const name = getFullName(info?.first_name, info?.middle_name, info?.last_name);
                    return (
                      <ClickWrapper
                        key={info?.id}
                        onClick={() => (canUpdate || isManager) && setInfoModal(incharge)}
                        style={{ cursor: 'pointer' }}>
                        <AvatarGroupRow
                          key={info?.id}
                          name={name}
                          baseUrl={generateEmployeeImgUrl(info?.id)}
                          role={incharge?.designation}
                        />
                      </ClickWrapper>
                    );
                  })}
                  {(isManager || canUpdate) && (
                    <>
                      <AddMembers setData={setOpenMemberModal} type="Team Member" />
                      {openMemberModal?.type === 'Team Member' && (
                        <AddMemeberModal
                          open={openMemberModal?.open}
                          setOpen={setOpenMemberModal}
                          type={'Team Member'}
                          selectedUser={employee_members}
                          handleListing={handleGetDetails}
                          filterOption={[
                            ...(project_manager_members ? [project_manager_members] : []),
                            ...(project_incharge_members || [])
                          ]}
                        />
                      )}
                    </>
                  )}
                </FlexWrapper>
              </Container>
            </FlexWrapper>

            <TitleBox>Assignee Billing IDs</TitleBox>
            <Table
              loading={loading}
              prefixCls="antCustomTable"
              columns={columns}
              dataSource={assigneeBillingIds || []}
              pagination={false}
            />
          </FlexWrapper>
        </ContentWrapper>
      )}
    </>
  );
};

export default GeneralInfo;

const AddMembers = ({ setData, type }) => {
  return (
    <FlexWrapper
      style={{
        borderRadius: '50%',
        border: '1px dashed #0E0E0E',
        height: '30px',
        width: '30px',
        fontSize: '20px'
      }}
      onClick={() => setData({ open: true, type: type })}
      cursor="pointer">
      +
    </FlexWrapper>
  );
};

GeneralInfo.propTypes = {
  setEditData: PropTypes.func,
  editData: PropTypes.any,
  updated: PropTypes.any,
  loading: PropTypes.bool,
  setLoading: PropTypes.func
};

const ContentWrapper = styled.div`
  background-color: white;
  height: 100%;
  border-radius: 12px;
  padding: 20px;
  font-family: ${fontFamilys?.poppinsFont};
  text-align: left;
`;
const FlexWrapperInfo = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: start;
    width: 100%;
  }

  .hms-remark {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px 10px;
  margin: 20px 0;
  @media (max-width: 768px) {
    grid-template-columns: 100%;
  }
`;

const Container = styled.div`
  width: ${({ width }) => width || 'fit-content'};
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 12px;
`;

const ManagerInchargeWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 20% 78%;
  gap: 20px;
  align-items: center;
  @media (max-width: 968px) {
    grid-template-columns: 100%;
    gap: 6px;
  }
`;
